// extracted by mini-css-extract-plugin
export default {"container":"ruuWgi","tabsContainer":"GlvJ9j"};